var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.variant === "icon"
        ? _c(
            "v-tooltip",
            {
              attrs: { top: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              attrs: {
                                icon: "",
                                flat: "",
                                depressed: "",
                                fab: "",
                                href: _vm.graphUrl,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            on
                          ),
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 18 18",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "aria-hidden": "true"
                                }
                              },
                              [
                                _c("circle", {
                                  attrs: {
                                    cx: "9",
                                    cy: "9",
                                    r: "3",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5"
                                  }
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: {
                                    cx: "3",
                                    cy: "3",
                                    r: "1.5",
                                    fill: "currentColor"
                                  }
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: {
                                    cx: "15",
                                    cy: "3",
                                    r: "1.5",
                                    fill: "currentColor"
                                  }
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: {
                                    cx: "3",
                                    cy: "15",
                                    r: "1.5",
                                    fill: "currentColor"
                                  }
                                }),
                                _vm._v(" "),
                                _c("circle", {
                                  attrs: {
                                    cx: "15",
                                    cy: "15",
                                    r: "1.5",
                                    fill: "currentColor"
                                  }
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "4.06",
                                    y1: "4.06",
                                    x2: "7.17",
                                    y2: "7.17",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3"
                                  }
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "13.94",
                                    y1: "4.06",
                                    x2: "10.83",
                                    y2: "7.17",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3"
                                  }
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "4.06",
                                    y1: "13.94",
                                    x2: "7.17",
                                    y2: "10.83",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3"
                                  }
                                }),
                                _vm._v(" "),
                                _c("line", {
                                  attrs: {
                                    x1: "13.94",
                                    y1: "13.94",
                                    x2: "10.83",
                                    y2: "10.83",
                                    stroke: "currentColor",
                                    "stroke-width": "1.3"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1048906191
              )
            },
            [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
          )
        : _vm.tooltip
        ? _c(
            "v-tooltip",
            {
              attrs: {
                right: _vm.tooltipRight,
                bottom: !_vm.tooltipRight,
                "open-delay": "300"
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    var attrs = ref.attrs
                    return [
                      _c(
                        "a",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "im-link-btn",
                              attrs: {
                                href: _vm.graphUrl,
                                target: _vm.target,
                                rel: "noopener noreferrer"
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            "a",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 18 18",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                "aria-hidden": "true"
                              }
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "9",
                                  cy: "9",
                                  r: "3",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "1.5"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "3",
                                  cy: "3",
                                  r: "1.5",
                                  fill: "currentColor"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "3",
                                  r: "1.5",
                                  fill: "currentColor"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "3",
                                  cy: "15",
                                  r: "1.5",
                                  fill: "currentColor"
                                }
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "1.5",
                                  fill: "currentColor"
                                }
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "4.06",
                                  y1: "4.06",
                                  x2: "7.17",
                                  y2: "7.17",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "13.94",
                                  y1: "4.06",
                                  x2: "10.83",
                                  y2: "7.17",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "4.06",
                                  y1: "13.94",
                                  x2: "7.17",
                                  y2: "10.83",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }
                              }),
                              _vm._v(" "),
                              _c("line", {
                                attrs: {
                                  x1: "13.94",
                                  y1: "13.94",
                                  x2: "10.83",
                                  y2: "10.83",
                                  stroke: "currentColor",
                                  "stroke-width": "1.3"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.showLabel && _vm.name
                            ? _c("span", { staticClass: "im-link-label" }, [
                                _vm._v(_vm._s(_vm.name))
                              ])
                            : _vm._e()
                        ]
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.tooltipText))])]
          )
        : _c(
            "a",
            {
              staticClass: "im-link-btn",
              attrs: {
                href: _vm.graphUrl,
                target: _vm.target,
                rel: "noopener noreferrer"
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: "12",
                      cy: "4",
                      r: "2.5",
                      stroke: "currentColor",
                      "stroke-width": "1.5"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      cx: "4",
                      cy: "20",
                      r: "2.5",
                      stroke: "currentColor",
                      "stroke-width": "1.5"
                    }
                  }),
                  _vm._v(" "),
                  _c("circle", {
                    attrs: {
                      cx: "20",
                      cy: "20",
                      r: "2.5",
                      stroke: "currentColor",
                      "stroke-width": "1.5"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d: "M12 6.5v5.5M12 12l-6.5 6M12 12l6.5 6",
                      stroke: "currentColor",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.showLabel && _vm.name
                ? _c("span", { staticClass: "im-link-label" }, [
                    _vm._v(_vm._s(_vm.name))
                  ])
                : _vm._e()
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }